declare var LtFramework: lt.Static;

const profileStore = LtFramework.getStore('ProfileStore') as lt.IProfileStore;

const profileData: lt.IProfile = profileStore.getInitialData();

export default profileData;
